import React, { useState } from "react";

import { useSelector } from "react-redux";
import { Button } from "../../../components/Field";
import Text from "../../../components/Text";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function ManualLinkSetup(props) {
    const {
        title,
        tag = "h2",
        text,
        separator = 0,
    } = props;

    const userProfile = useSelector((state) => state.storage.data);
    const copyLink = `${process.env.REACT_APP_API_URL}/rss/feed/${userProfile.id}?v=${Date.now()}`; 
    const [showCopyMessage, setShowCopyMessage] = useState(false);

    const copyClip = (copyLink) => {
        if (!showCopyMessage) {
            navigator.clipboard.writeText(copyLink)
                .then(() => {
                    setShowCopyMessage(true);
                    setTimeout(() => {
                        setShowCopyMessage(false)
                    }, 2000)
                })
                .catch((err) => {
                    console.error('Failed to copy: ', err);
                });
        }
    }

    if (!userProfile?.id) return null;

    return (
        <Section className={`${style.manualLinkSetup}`}>
            {
                separator === 1 && (
                    <div className={style.separator} />
                )
            }
            {
                title && (
                    <Title
                        className="fontTeko"
                        tag={tag}
                        transform="textUpperCase"
                    >
                        {title}
                    </Title>
                )
            }
            {
                text && (
                    <>
                        <Spacer size={"24"} />
                        <Text
                            text={text}
                        />
                    </>
                )
            }
            <div className={style.copyWrap}>
                <div className={style.inputWrap}>
                    <Text text={copyLink} />
                </div>
                <Button 
                    disabledTip={"test"}
                    color="buttonPrimary"
                    label="Copy"
                    className={style.coptBtn}
                    onClick={() => copyClip(copyLink)}
                />
                {
                    showCopyMessage && (
                        <div className={style.copyMessage}>
                            <Text text="Link Copied" />
                        </div>
                    )
                }
            </div>
        </Section>
    )
};